import './PaymentPage.scss';

import { useState } from 'react';
import { useApp } from '../app-context';
import { TSPage, TSMonthInput } from '../components/commons';
import { DashService } from '../services/DashService';
import { Slide, Fade } from 'react-awesome-reveal';
import { Utils } from '../Utils';

const PaymentPage = (props) => {
  const [state, dispatcher] = useApp();

  const [stateCard, setStateCard] = useState({});
  const [stateErrors, setStateErrors] = useState({});
  const [stateReady, setStateReady] = useState(true);

  const handleClose = (e) => {
    e.preventDefault();
    dispatcher({ action: "closePage", params: { id: "payment" } });
  };

    const preparePayment = data => {
    data.policyId = props.policyId;
    return DashService.processPaymentDetails(dispatcher, state, data);
  };

  const validateFields = function () {
    var errors = {};
    if (!stateCard.card)
      errors.card = "אנחנו צריכים את מספר כרטיס האשראי שלך כדי להתקדם";

        if (stateCard.exp?.length !== 4)
            errors.exp = "יש להזין תוקף חוקי";

        if (!stateCard.exp)
            errors.exp = "יש להזין תוקף";

        if (!stateCard.cvv)
            errors.cvv = "יש להזין קוד אימות";

    if (!stateCard.ownerFirstName)
      errors.ownerFirstName = "יש להזין שם פרטי של בעל/ת הכרטיס";

    if (!stateCard.ownerLastName)
      errors.ownerLastName = "יש להזין שם משפחה של בעל/ת הכרטיס";

    if (!stateCard.ownerId)
      errors.ownerId = "יש להזין את תעודת הזהות של בעל/ת הכרטיס";

    setStateErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const onFieldChange = function (id, e) {
    const cs = { ...stateCard };
    cs[id] = e.target.value;
    setStateCard(cs);
  };

  const handlePay = (e) => {
    e.preventDefault();

    if (!validateFields()) {
      return;
    }

        if (!stateReady)
            return;

    setStateReady(false);
    preparePayment(stateCard)
            .then(res => {
        if (res.status !== 0) {
                    Utils.displaySimpleMsg(dispatcher, "אופס, לא הצלחנו לאשר את פרטי האשראי במועד זה");
        } else {
          if (res.displayNameChangeWarn) {
                        Utils.displaySimpleMsg(dispatcher,
                            <div onClick={(e) => {
                  e.stopPropagation();
                            }}>
                <h3>בקשתך נשלחה!</h3>
                <br></br>
                <p style={{ fontWeight: "bold" }}>
                  אבל שמנו לב שהשם שהזנת שונה מהשם המעודכן בפוליסה.
                </p>
                <p style={{ fontWeight: "bold" }}>
                                    לעדכון שם נודה ליצירת קשר
                                    &nbsp;<a href='https://wa.me/message/GTVKLUTXQRDCL1'
                                        target="_blank">בוואטסאפ</a>&nbsp;
                                    או במייל
                                    &nbsp;<a href='mailto:office@chayuta.com'
                                        target="_blank">office@chayuta.com</a>&nbsp;.
                </p>
                            </div>);
          } else {
                        Utils.displaySimpleMsg(dispatcher, "תודה על מילוי הפרטים. בקשתך הועברה לטיפול נציג. בתום הטיפול תישלח הודעת SMS.");
          }
          dispatcher({ action: "closePage", params: { id: "payment" } });
        }
      })
            .catch(ex => {
                Utils.displaySimpleMsg(dispatcher, ex?.message ? ex.message : "לא ניתן לשלוח את הפרטים במועד זה, אנא נסו שוב מאוחר יותר");
                console.error('payment error:', ex);
      })
      .finally(() => {
        setStateReady(true);
      });
  };

  const calculateNumOfPayments = function (policyEndDate) {
    let endDate = Utils.dateStringToObj(policyEndDate);
    let now = new Date();

    let months = (endDate.getFullYear() - now.getFullYear()) * 12;
    months -= now.getMonth();
    months += endDate.getMonth();
    months += 1;

        if (now.getDate() >= 16)
            months -= 1;

    return months <= 0 ? 0 : months - 2;
  };

  const numberOfPaymentsSelect = function (numOfPayments) {
        let items = [<option key='' value=''>בחר</option>];

    for (let i = 1; i <= numOfPayments; i++) {
            items.push(<option key={i} value={i}>{i}</option>);
    }
    return (
      <div className="row double">
        <div className="part">
          <label>מספר תשלומים</label>
                    <select id="numOfPayments" className="numOfPaymentsSelect" onChange={onFieldChange.bind(this, "numOfPayments")}>
            {items}
          </select>
                    <div className={"validationError " + (stateErrors.numOfPayments && "on")}>{stateErrors.numOfPayments}</div>
        </div>
      </div>
    );
  };

  let numOfPayments = calculateNumOfPayments(props.endDate);

    const cb = (_inview, ioe) => { ioe.target.querySelector(".container").classList.add("on"); }
  return (
    <TSPage name={props.name}>
      <Slide direction="up" duration="500" onVisibilityChange={cb}>
        <div className="container on">
            <div className="header">
                <button className="btn right" onClick={handleClose}>
                    <img src="img/cross.svg" alt="back" />
                </button>
                <div className="title">
                    עדכון אמצעי תשלום
                </div>
            </div>

            <div className="content" style={{ marginLeft: -state?.uiParams?.scrollSize?.w + "px" }}>
                <form onSubmit={handlePay}>
                <div>
                    <div className="row">
                        <label>מס' כרטיס אשראי</label>
                        <input type="text" name="cc-number" inputMode="numeric" autoComplete="cc-number" onChange={onFieldChange.bind(this, "card")} className={stateErrors.card && "error"}></input>
                        <div className={"validationError " + (stateErrors.card && "on")}>{stateErrors.card}</div>
                    </div>
                    <div className="row double">
                        <div className="part">
                            <label>תוקף</label>
                            <TSMonthInput type="text" onChange={onFieldChange.bind(this, "exp")} className={stateErrors.exp && "error"} />
                            <div className={"validationError " + (stateErrors.exp && "on")}>{stateErrors.exp}</div>
                        </div>
                        <div className="part">
                            <label>cvv</label>
                            <input type="text" name="cc-csc" inputMode="numeric" autoComplete="cc-csc" onChange={onFieldChange.bind(this, "cvv")} className={stateErrors.cvv && "error"}></input>
                            <div className={"validationError " + (stateErrors.cvv && "on")}>{stateErrors.cvv}</div>
                        </div>
                    </div>
                    <div className="row double">
                        <div className="part">
                            <label>שם פרטי של בעל/ת הכרטיס</label>
                            <input type="text" name="cc-given-name" autoComplete="cc-given-name" onChange={onFieldChange.bind(this, "ownerFirstName")} className={stateErrors.ownerFirstName && "error"}></input>
                            <div className={"validationError " + (stateErrors.ownerFirstName && "on")}>{stateErrors.ownerFirstName}</div>
                        </div>
                        <div className="part">
                            <label>שם משפחה</label>
                            <input type="text" name="cc-family-name" autoComplete="cc-family-name" onChange={onFieldChange.bind(this, "ownerLastName")} className={stateErrors.ownerLastName && "error"}></input>
                            <div className={"validationError " + (stateErrors.ownerLastName && "on")}>{stateErrors.ownerLastName}</div>
                        </div>
                    </div>
                    <div className="row">
                        <label>ת.ז של בעל/ת הכרטיס</label>
                        <input type="numeric" name="cc-pid" onChange={onFieldChange.bind(this, "ownerId")} className={stateErrors.ownerId && "error"}></input>
                        <div className={"validationError " + (stateErrors.ownerId && "on")}>{stateErrors.ownerId}</div>
                        </div>
                            {
                                numOfPayments > 0 ? numberOfPaymentsSelect(numOfPayments) : undefined
                            }
                        </div>
                        <div className="txt">תשומת ליבך כי לא ניתן לשלם באמצעות כרטיס דיירקט / דביט / כרטיס נטען מכל סוג.</div>
                        {props.policyType !== 1 ? [
                            <div className="txt">באם זהות המשלם שונה מזהות בעל הפוליסה, נבקש <a target="_blank" href='https://assets.chayuta.com/shomera/payer-affinity.pdf'>למלא טופס</a> זיקה בין המשלם למבוטח ולשלוח למייל  <a href='mailto:office@chayuta.com'>office@chayuta.com</a>.</div>,
                            <div className="txt">חלוקה לתשלומים תישא דמי אשראי בגובה של עד 10% לשנת ביטוח.</div>
                        ] : undefined}
                        <div className="txt">מספר התשלומים תלוי בפרק הזמן שנותר עד למועד חידוש הפוליסה.</div>
                        <div className="txt important">במידה ועדכון אמצעי התשלום נעשה עבור הסדרת חוב - נבקש לשים לב שהעדכון מהווה הסכמה גם עבור חיוב מיידי לכל התקופה בה הפוליסה היתה בתוקף אך לא נגבה תשלום עבורה.</div>
                        <div className='btnDiv'>
                        <button type="submit" className={"purchaseButton" + (!stateReady ? " disabled--" : "")}>עדכון</button>
                    </div>
                </form>
            </div>
            {!stateReady ?
            <Fade duration="300">
              <div className="waiter">
                <img src="/img/loading.svg" className="slow-rotate reverse" alt="" />
              </div>
            </Fade>
            : undefined
            }
        </div>
      </Slide>
    </TSPage>
  );
}

export { PaymentPage }
